import { Config } from '@adornis/config/config.js';

export const zoomConfig = new Config('zoom-config', {
  clientID: {
    client: true,
    env: true,
    name: 'ZOOM_CLIENT_ID',
    required: false,
    defaultVal: '',
  },
  clientSecret: {
    client: false,
    env: true,
    name: 'ZOOM_CLIENT_SECRET',
    required: false,
    defaultVal: '',
  },
  enabled: {
    env: true,
    required: false,
    client: true,
    name: 'USE_ZOOM_INTEGRATION',
    parse: (val: string | boolean) => {
      return val === 'true' || val === true;
    },
    defaultVal: 'false',
  },
  webhookSecretToken: {
    env: true,
    name: 'ZOOM_WEBHOOK_SECRET_TOKEN',
    client: false,
    required: false,
    defaultVal: '',
  },
});
